import { POINTS_ENABLED } from '@/config/consts'
import { assets } from '@/ui/assets'
import { Tooltip, TooltipContentLong, TooltipTrigger } from '@/ui/atoms/tooltip/Tooltip'
import { TooltipContentLayout } from '@/ui/atoms/tooltip/TooltipContentLayout'
import Image from 'next/image'

export function EarnPointsBadge() {
  if (!POINTS_ENABLED) {
    return null
  }

  return (
    <Tooltip>
      <TooltipTrigger
        asChild
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
        }}
      >
        <div className="flex items-center gap-1 rounded">
          <span className="flex items-center gap-1 rounded border border-white/20 px-1 py-1">
            <Image src={assets.hypurrPawNoShadow} alt="HypurrFi Points" className="h-3.5 w-3.5" />
          </span>
        </div>
      </TooltipTrigger>

      <TooltipContentLong forceMount>
        <TooltipContentLayout>
          <TooltipContentLayout.Header>
            <TooltipContentLayout.Icon src={assets.hypurrPawNoShadow} />
            <TooltipContentLayout.Title>Eligible for HP</TooltipContentLayout.Title>
          </TooltipContentLayout.Header>

          <TooltipContentLayout.Body>
            <span className="text-sm">
              This vault is earning points in accordance with the strategy utilized. Check the underlying lending
              markets for clarity on points multipliers.
            </span>
          </TooltipContentLayout.Body>
        </TooltipContentLayout>
      </TooltipContentLong>
    </Tooltip>
  )
}
